import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { CPanel, CTextInput } from '@appcues/component-library';
import {
  selectAccountMeta,
  selectAccountMetaSynced,
} from 'reducers/account/meta';

export const AccountAPIKeysPanel = ({ accountId, accountUUID, isMetaSynced }) =>
  isMetaSynced ? (
    <CPanel title="Account API keys">
      <CTextInput.Group label="Account ID">
        <CTextInput readOnly value={accountId} />
      </CTextInput.Group>
      <CTextInput.Group label="API key">
        <CTextInput readOnly value={accountUUID} />
      </CTextInput.Group>
    </CPanel>
  ) : (
    false
  );

AccountAPIKeysPanel.propTypes = {
  accountId: PropTypes.string,
  accountUUID: PropTypes.string,
  isMetaSynced: PropTypes.bool,
};
AccountAPIKeysPanel.defaultProps = {
  accountId: '',
  accountUUID: '',
  isMetaSynced: false,
};

const mapStateToProps = state => {
  const meta = selectAccountMeta(state) || {};
  return {
    accountId: meta.id,
    accountUUID: meta.uuid,
    isMetaSynced: selectAccountMetaSynced(state),
  };
};

export default connect(mapStateToProps)(AccountAPIKeysPanel);
